module.exports = __webpack_public_path__ + "static/media/17UN-Women6.b02ee91e.jpg";